<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Kirim Serial Stokis</div>
		</div>
		<div class="mt-5">
			<v-row v-if="stockistQuota.length > 0">
				<v-col cols="12" class="pt-0 d-flex justify-end">
					<v-card width="300" class="pa-2 elevation-0 rounded-xl hover-shadow h-100">
						<div class="text-center">
							<div class="font-size-11 font-weight-bold cl-grey text-capitalize d-flex align-center justify-space-between pa-2" v-for="serial in stockistQuotaList" :key="serial.serial_type_id">
								<span>Kuota serial {{ (serial.serial_type_name == 'star') ? 'Premium' : serial.serial_type_name }}</span>
								<span class="primary--text">{{ serial.serial_quota | toNumber }}</span>
							</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6" md="4" lg="4" xl="3">
					<v-card min-height="130" class="pa-4 elevation-0 rounded-xl hover-shadow">
						<v-row class="align-center">
							<v-col cols="12" sm="12" md="12" xl="12"><div class="font-size-12 primary--text">Input Kode Mitra</div></v-col>
						</v-row>
						<div class="pt-2">
							<v-text-field
								label="Kode Mitra"
								color="primary"
								hide-details="auto"
								v-model="network_code"
								:error-messages="(errorValidation !== undefined && errorValidation['network_code'] !== undefined ) ? [errorValidation['network_code']] : []"
								@keypress="changeNetworkCode()">
							</v-text-field>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6" md="4" lg="4" xl="3">
					<v-card min-height="130" class="pa-4 elevation-0 rounded-xl hover-shadow">
						<v-row class="align-center">
							<v-col cols="12" sm="12" md="12" xl="12"><div class="font-size-12 primary--text">Tipe Serial</div></v-col>
						</v-row>
						<div class="pt-2" v-if="serialType.length > 0">
							<v-select
								label="Pilih Tipe Serial"
								color="primary"
								no-data-text="Tidak Ada Tipe Serial"
								hide-details="auto"
								:items="serialTypeList"
								item-text="serial_type_label"
								item-value="serial_type_id"
								v-model="serial_type_id"
								:error-messages="(errorValidation !== undefined && errorValidation['serial_type_id'] !== undefined ) ? [errorValidation['serial_type_id']] : []">
							</v-select>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6" md="4" lg="4" xl="3">
					<v-card min-height="130" class="pa-4 elevation-0 rounded-xl hover-shadow">
						<v-row class="align-center">
							<v-col cols="12" sm="12" md="12" xl="12"><div class="font-size-12 primary--text">Jumlah Serial</div></v-col>
						</v-row>
						<div class="pt-2 d-flex">
							<v-col cols="3" sm="3" md="2" xl="2" class="pb-0 px-0 text-center">
								<v-btn icon small class="px-0" @click="decQty()">
									<v-icon size="30" color="grey darken-1">mdi-minus-circle-outline</v-icon>
								</v-btn>
							</v-col>
							<v-col cols="6" sm="6" md="8" xl="8" class="pb-0">
								<v-text-field
									dense
									color="primary"
									class="input-text-center"
									hide-details="auto"
									v-model="serial_qty"
									@paste.prevent
									@keypress="onlyNumber"
									@keyup="adjustQty()">
								</v-text-field>
								<div class="pt-1 font-size-9 grey--text text--darken-2">*Maksimal 1000 Serial</div>
							</v-col>
							<v-col cols="3" sm="3" md="2" xl="2" class="pb-0 px-0 text-center">
								<v-btn icon small class="px-0" @click="addQty()">
									<v-icon size="30" color="primary">mdi-plus-circle-outline</v-icon>
								</v-btn>
							</v-col>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="12" md="12" lg="12" xl="9" class="text-right">
					<v-card class="pa-4 elevation-0 rounded-xl hover-shadow">
						<v-btn large width="140" depressed color="primary" class="rounded-xl" :disabled="!network_code || !serial_type_id || !serial_qty" :loading="btn_loading" @click="showConfirm()">
							<v-icon>mdi-arrow-right</v-icon>
							<span class="pl-2">Kirim</span>
						</v-btn>
					</v-card>
				</v-col>
			</v-row>
		</div>
		<ModalKonfirm ref="modalKonfirm" :network_code="network_code" :member_name="member_name" :serial_qty="serial_qty" @action="processSend"></ModalKonfirm>
		<ModalGagal ref="modalGagal" :msg="msg_failed"></ModalGagal>
		<ModalSukses ref="modalSukses" :successResponse="successResponse"></ModalSukses>
	</v-col>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ModalKonfirm from './components/ModalKonfirm';
import ModalGagal from '@/components/modals/vo-general/ModalGagal';
import ModalSukses from './components/ModalSukses';

export default {
	components: {
		ModalKonfirm, ModalGagal, ModalSukses
	},
	data() {
		return {
			network_code: 'SB100000001',
			member_name: '',
			serialTypeList: [],
			stockistQuotaList: [],
			serial_type_id: '',
			serial_qty: 1,
			btn_loading: false,
			msg_failed: "Mohon Maaf kirim serial Anda Gagal. Silakan ulangi kembali proses kirim serial",
		}
	},
	computed: {
		...mapState('opsi', ['memberData', 'stockistQuota']),
		...mapState('stokisArea', ['serialType']),
		...mapState(['errorValidation', 'successResponse']),
	},
	methods: {
		...mapActions('opsi', ['getMemberByCode', 'getStockistQuota']),
		...mapActions('stokisArea', ['getSerialType', 'sendSerial']),
		...mapMutations('opsi', ['emptyMemberData']),
		...mapMutations(['emptyErrorValidation']),

		async getData() {
			const authData = await localStorage.getItem('mlmcore-vo-auth-data');
			const data = await JSON.parse(authData)
			await this.getSerialType().then(() => { 
				let serials = []
				this.serialType.map(serial => {
					if (serial.serial_type_label == 'Ceria') serials[0] = serial
					else if (serial.serial_type_label == 'Ekonomis') serials[1] = serial
					else if (serial.serial_type_label == 'Reguler') serials[2] = serial
					else if (serial.serial_type_label == 'Supreme') serials[3] = serial
					else if (serial.serial_type_label == 'Free') serials[4] = serial
				})

				serials[2].serial_type_label = 'Premium'
				this.serialTypeList = serials
			})
			await this.getStockistQuota({ code: data.member_network_code }).then(() => { 
				let quotas = []
				this.stockistQuota.map(serial => {
					if (serial.serial_type_name == 'ceria') quotas[0] = serial
					else if (serial.serial_type_name == 'economy') quotas[1] = serial
					else if (serial.serial_type_name == 'star') quotas[2] = serial
					else if (serial.serial_type_name == 'supreme') quotas[3] = serial
					else if (serial.serial_type_name == 'free') quotas[4] = serial
				})

				quotas[1].serial_type_name = 'ekonomis'
				quotas[2].serial_type_name = 'premium'
				this.stockistQuotaList = quotas
			})
		},
		addQty() {
			if (this.serial_qty >= 0) {
				this.serial_qty++
			}
			if (this.serial_qty > 1000) {
				this.serial_qty = 1000
			}
		},
		decQty() {
			if (this.serial_qty > 1) {
				this.serial_qty--
			}
		},
		adjustQty() {
			if (this.serial_qty <= 0) {
				this.serial_qty = 1
			}
			if (this.serial_qty > 1000) {
				this.serial_qty = 1000
			}
		},
		showConfirm() {
			this.btn_loading = true
			this.getMemberByCode({ network_code: this.network_code }).then((res) => {
				this.member_name = res.member_name
				this.btn_loading = false
				this.$refs.modalKonfirm.modalShow()
			}).catch(() => {
				this.btn_loading = false
			})
		},
		changeNetworkCode() {
			this.emptyErrorValidation()
		},
		resetNetworkCode() {
			this.network_code = ''
		},
		processSend() {
			this.$refs.modalKonfirm.loadingButton()
			const params = {
				member_network_code: this.network_code,
				serial_type_id: this.serial_type_id,
				serial_qty: this.serial_qty,
			}
			this.sendSerial(params).then(() => {
				this.$refs.modalKonfirm.modalHide()
				this.$refs.modalSukses.modalShow()
				this.getData()
			}).catch(() => {
				this.$refs.modalKonfirm.modalHide()
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Kirim Serial Stokis`)
		this.getData()
	},
};
</script>